import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/components/site/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Detect the OAuth redirect synchronously during render (prevents race conditions).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <SmoothScroll>
      <div className="App relative">
        <div className="grain-overlay" aria-hidden="true" />
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
      </div>
    </SmoothScroll>
  );
}

export default App;
